// 会话凭据类参数：跨站免登（udid / user，IP 入口放在 # 里）、App 免登（appToken）、ticket 换票。
// 只去掉这些，cid / tab 等业务参数保留 —— 埋点和 Sentry 排查都要用
const SENSITIVE_PARAMS = ["udid", "token", "appToken", "user", "ticket"];
const SENSITIVE_RE = new RegExp(`[?&#](${SENSITIVE_PARAMS.join("|")})=`);

/** 参数串里有敏感参数才重组；没有的原样返回，避免 URLSearchParams 重新编码改动它 */
const stripParams = (params: string, lead: "?" | "#") => {
  if (!SENSITIVE_RE.test(lead + params)) return params;
  const parsed = new URLSearchParams(params);
  SENSITIVE_PARAMS.forEach((key) => parsed.delete(key));
  return parsed.toString();
};

/** 去掉 URL 查询参数与 # 里的会话凭据参数，其余原样保留 */
export const redactUrl = <T extends string | undefined>(url: T): T => {
  if (typeof url !== "string" || !SENSITIVE_RE.test(url)) return url;
  const h = url.indexOf("#");
  const beforeHash = h < 0 ? url : url.slice(0, h);
  const q = beforeHash.indexOf("?");
  const base = q < 0 ? beforeHash : beforeHash.slice(0, q);
  const query = q < 0 ? "" : stripParams(beforeHash.slice(q + 1), "?");
  const hash = h < 0 ? "" : stripParams(url.slice(h + 1), "#");
  return (base + (query ? `?${query}` : "") + (hash ? `#${hash}` : "")) as T;
};
